module.exports = __webpack_public_path__ + "img/logo_237.e8be7a54.png";